export default __webpack_public_path__ + "static/media/MsThi.a37992be.png";